import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

export default class NetworkDomainAlarmChart extends Component {
  constructor() {
    super();
    this.state = {
      series: [
        {
          name: "Critical",
          data: [576, 643, 920, 1057, 6],
        },
        {
          name: "Information",
          data: [0, 2, 35, 31, 6],
        },
        {
          name: "Major",
          data: [914, 1520, 947, 237, 325],
        },
        {
          name: "Minor",
          data: [3459, 737, 810, 831, 6],
        },
        {
          name: "Warning",
          data: [16, 2, 336, 31, 6],
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 5,
                style: {
                  fontSize: "12px",
                  fontWeight: 700,
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return val;
          },
          textAnchor: "middle",
          distributed: false,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "10px",
            fontWeight: "700",
          },
        },
        xaxis: {
          categories: ["SEM", "EAN", "FTTP", "HFC Network", "DWDM"],

          labels: {
            style: {
              fontSize: "10px",
              fontWeight: 700,
              margin: {
                top: 0, // Adjust these margins to control spacing around labels
                right: 0,
                bottom: 0,
                left: 0,
              },
            },
            rotate: -30,
          },
          title: {
            text: "Alarm Count", // Title for the x-axis
            style: {
              fontSize: "14px",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "10px",
              fontWeight: "bold",
            },
          },
          title: {
            text: "Network Domain", // Title for the x-axis
            style: {
              fontSize: "14px",
              padding: "10px",
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const allValues = series.map((s) => s[dataPointIndex]);
            const labels = w.globals.seriesNames;
            const colors = w.globals.colors;
            const category = w.globals.labels[dataPointIndex];
            console.log(colors);

            let tooltipContent = '<div class="tooltipCustom">';
            tooltipContent += `<div class="tooltipTitle">${category}</div>`;

            series.forEach((s, i) => {
              const fontWeight = seriesIndex === i ? "bold" : "normal"; // Apply bold font to the hovered stack
              const fontColor = seriesIndex === i ? colors[i] : "black"; // Apply color of the hovered stack and black to the rest
              const statusCircle = `<span class="statusCircle" style="background-color:${colors[i]}"></span>`;
              tooltipContent += `<div><span class="statusCircleWrapper">${statusCircle}</span><span style="color:${fontColor}; font-weight:${fontWeight}">${labels[i]}: ${allValues[i]}</span></div>`;
            });

            tooltipContent += "</div>";
            return tooltipContent;
          },
        },
        // colors: ["#F16532", "#F6A961", "#38B69C", "#659BCE", "#B0CEE8"],

        colors: [
          "#F16532", // Critical
          "#B0CEE8", // Information
          "#F6A961", // Major
          "#38B69C", // Minor
          "#659BCE", // Warning
        ],

        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontWeight: "10px",
          //   offsetX: 40,
        },
      },
    };
  }

  render() {
    return (
      <div>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={300}
        />
      </div>
    );
  }
}
